import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 18,
	viewBox: "0 0 17 18",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		d: "M8.02783 15.355L5.94184 15.3552C2.96191 15.3765 1.76011 14.1917 1.73887 11.2117L1.70789 6.86519C1.68666 3.88527 2.87146 2.68346 5.85138 2.66222L8.02773 2.66222M6.05665 9.01426L13.6431 8.96019M12.1724 11.2041L14.3898 8.95487L12.1406 6.73751",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) }), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2203_9273",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(16.1135 16.9429) rotate(179.592)"
		})
	}) })]
});
export default SvgLogout;
